/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { i as isFunction_1 } from '../../../_chunks/dep-1f286011.mjs';
import { i as isNumber_1 } from '../../../_chunks/dep-af8c0169.mjs';
import '../../../_chunks/dep-34428f12.mjs';
import '../../../_chunks/dep-1c40d002.mjs';
import '../../../_chunks/dep-8a0ff305.mjs';
import '../../../_chunks/dep-3ced59c9.mjs';
import '../../../_chunks/dep-61150968.mjs';

function isRowSelectedDisabled(selectColumn, row, rowIndex) {
  var disabled = isFunction_1(selectColumn.disabled) ? selectColumn.disabled({
    row: row,
    rowIndex: rowIndex
  }) : selectColumn.disabled;
  if (selectColumn.checkProps) {
    if (isFunction_1(selectColumn.checkProps)) {
      disabled = disabled || selectColumn.checkProps({
        row: row,
        rowIndex: rowIndex
      }).disabled;
    } else if (selectColumn.checkProps === "object") {
      disabled = disabled || selectColumn.checkProps.disabled;
    }
  }
  return !!disabled;
}
function getColWidthAttr(col, attrKey) {
  var attr = col[attrKey];
  return isNumber_1(attr) ? attr : parseFloat(attr);
}

export { getColWidthAttr, isRowSelectedDisabled };
//# sourceMappingURL=utils.mjs.map
